import {call, put, takeLatest} from 'redux-saga/effects';
import pageActions from '../actions/page.actions';
import PagesApi from '../api/PagesApi';
import errorActions from '../actions/error.actions';

function* fetchPage(action) {
    try {
        const page = yield call(PagesApi.getPage, action.payload);
        yield put(pageActions.getPageSuccess(page));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(pageActions.getPageFailed(e));
    }
}

function* pageSaga() {
    yield takeLatest(pageActions.TYPES.GET_PAGE, fetchPage);
}

export default pageSaga;
